import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { usePatchForm } from '../../providers/PatchFormProvider';

const RebootDevice = () => {
  const { patchFormData, setPatchFormData } = usePatchForm();

  const [isExpanded, setIsExpanded] = useState(false);

  const [reboot, setReboot] = useState({
    ActionType: 'RebootDevice',
    WhenToExecute: 'PostRemediation',
  });
  const [apply, setApply] = useState(false);

  const applyReboot = () => {
    setApply(true);
    setPatchFormData((prev) => {
      const updatedList = (prev.RemediationPlanActionList ?? []).filter((a) => a.ActionType !== 'RebootDevice');
      return {
        ...prev,
        RemediationPlanActionList: [...updatedList, reboot],
      };
    });
    setIsExpanded(false);
  };

  useEffect(() => {
    if (patchFormData?.RemediationPlanActionList) {
      const savedReboot = patchFormData.RemediationPlanActionList.find((action) => action.ActionType === 'RebootDevice');
      if (savedReboot) {
        setReboot(savedReboot);
        setApply(true);
      }
    }
  }, [patchFormData]);

  return (
    <div className={`bg-[#1e1e1e] text-white p-4 rounded-md border ${apply ? 'border-green-500' : 'border-gray-600'}`}>
      {/* Dropdown Header */}
      <div
        className="flex justify-between items-center cursor-pointer p-3 bg-[#2a2a2a] rounded-md"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span>Reboot Device</span>
        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      {/* Dropdown Content */}
      {isExpanded && (
        <div className="mt-2 bg-[#2a2a2a] border border-gray-600 rounded-md p-4">
          {/* Radio Button Options */}
          <div className="flex items-center gap-x-6">
            <label className="flex items-center gap-x-2">
              <input
                type="radio"
                name="rebootOption"
                value="PostRemediation"
                checked={reboot.WhenToExecute === 'PostRemediation'}
                onChange={(e) =>
                  setReboot((prev) => ({
                    ...prev,
                    WhenToExecute: e.target.value,
                  }))
                }
              />
              <span>Postpatching</span>
            </label>
            <label className="flex items-center gap-x-2">
              <input
                type="radio"
                name="rebootOption"
                value="PreRemediation"
                checked={reboot.WhenToExecute === 'PreRemediation'}
                onChange={(e) =>
                  setReboot((prev) => ({
                    ...prev,
                    WhenToExecute: e.target.value,
                  }))
                }
              />
              <span>Prepatching</span>
            </label>
          </div>

          {/* Action Buttons */}
          <div className="mt-3 flex justify-start gap-3 ">
            <button
              className="px-4 py-2 border border-gray-400 rounded-[30px] hover:bg-gray-700 transition"
              onClick={() => {
                setApply(false);
                setIsExpanded(false);
              }}
            >
              Cancel
            </button>
            <button className="px-4 py-2 bg-red-600 rounded-[30px] hover:bg-red-700 transition" onClick={() => applyReboot()}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RebootDevice;
